import { ContainerType } from './container.types';
import { nonNil } from '../utility';

const SPLIT_SCREEN_CONTAINER_TYPES = new Set<ContainerType>([
    ContainerType.PROJECT_MOTORIC,
    ContainerType.PROJECT_VISUAL,
]);

const IMG_DB_CONTAINER_TYPES = new Set<ContainerType>([ContainerType.IMAGE_DB]);

export const isContainerTypeCompatibleWithTarget = (
    routeContainerType: string | null | undefined,
    allowedContainerTypes: Set<ContainerType>
): boolean =>
    nonNil(routeContainerType) &&
    allowedContainerTypes.has(routeContainerType as ContainerType);

export const isContainerTypeAllowedForSplitScreen = (
    routeContainerType: string | null | undefined
): boolean =>
    isContainerTypeCompatibleWithTarget(
        routeContainerType,
        SPLIT_SCREEN_CONTAINER_TYPES
    );

export const isContainerTypeAllowedForImgDb = (
    routeContainerType: string | null | undefined
): boolean =>
    isContainerTypeCompatibleWithTarget(
        routeContainerType,
        IMG_DB_CONTAINER_TYPES
    );
